import { Alert, AlertDescription } from "@/components/ui/alert";
import { SrIcon } from "@/components/ui/SrIcon";
import { summarizeMissingDays, hasGaps, describeGaps } from "./missing-days";
import { firstGapDate } from "./day-status";
import type { TimeGap } from "@/hooks/use-time-gaps";

interface Props {
  gaps: TimeGap[];
  /** Månedsnavn i småbokstaver, f.eks. «september». */
  monthLabel: string;
  /** Ruller til første dag med hull (VIB-3034). */
  onJump: (date: string) => void;
}

/**
 * VIB-2083: oppsummerer hull i måneden rett over Avslutt-knappen.
 *
 * Oversikten øverst viser hvilke dager det gjelder. Denne gjentar tallet der
 * den ansatte faktisk trykker, med lenke tilbake til dagene.
 *
 * Varsler, blokkerer ikke (Erik 28.09). Knappen fungerer uansett — den ansatte
 * skal bare ikke kunne si at hen ikke visste.
 */
export function CloseMonthGapSummary({ gaps, monthLabel, onJump }: Props) {
  const summary = summarizeMissingDays(gaps);
  if (!hasGaps(summary)) return null;
  const first = firstGapDate(gaps);

  return (
    <Alert className="border-amber-200 bg-amber-50">
      <SrIcon name="alert-circle" className="h-4 w-4 text-amber-600" />
      <AlertDescription className="text-amber-900 text-sm">
        <span className="font-medium">Du har {describeGaps(summary)} i {monthLabel}.</span>{" "}
        Før det som mangler nå, du kan ikke endre timene etter at måneden er avsluttet.
        {first && (
          <>
            {" "}
            <button
              type="button"
              onClick={() => onJump(first)}
              className="underline underline-offset-2 font-medium"
            >
              Vis dagene
            </button>
          </>
        )}
      </AlertDescription>
    </Alert>
  );
}

export default CloseMonthGapSummary;
